import { render, staticRenderFns } from "./pagination.component.vue?vue&type=template&id=f80046da"
import script from "./pagination.component.ts?vue&type=script&lang=ts&external"
export * from "./pagination.component.ts?vue&type=script&lang=ts&external"
import style0 from "./pagination.component.vue?vue&type=style&index=0&id=f80046da&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports